import styled from "styled-components";

export const Container = styled.nav`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  margin-bottom: 12px;
  font-size: 13px;
  color: ${(props) => props.theme.colors.neutral400};

  ol {
    list-style: none;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
  }

  li {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    max-width: 320px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .separator {
    color: ${(props) => props.theme.colors.neutral400};
  }

  a {
    color: ${(props) => props.theme.colors.neutral600};
    transition: color 0.2s ease;

    :hover {
      color: ${(props) => props.theme.colors.primary};
    }
  }

  .current {
    color: ${(props) => props.theme.colors.neutral900};
    font-weight: 700;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
